import TrafficControllerFeedbackSearchBar from './TrafficControllerFeedbackSearchBar';

export default TrafficControllerFeedbackSearchBar;
